import { Component, OnInit, inject } from '@angular/core';
import {Observable, zip} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {first, map, mergeMap} from 'rxjs/operators';
import {ClientService} from '../../../client/client.service';
import {Client} from '../../../client/client';
import {Prestatie} from '../../../prestatie/prestatie';
import {PrestatieService} from '../../../prestatie/prestatie.service';
import {Thuisverzorger} from '../../../thuisverzorger/thuisverzorger';
import {ThuisverzorgerService} from '../../../thuisverzorger/thuisverzorger.service';
import {Diensten} from '../../../dienst/diensten';
import {DienstService} from '../../../dienst/dienst.service';
import {TaakTipAantal} from '../../../tip/taak-tip-aantal';
import {TipService} from '../../../tip/tip.service';
import User from '../../../core/auth/user';
import {AuthService} from '../../../core/auth/auth.service';

@Component({
    templateUrl: './prestatie.page.html',
    styleUrls: ['./prestatie.page.scss'],
    standalone: false
})
export class PrestatiePage implements OnInit {
  private authService = inject(AuthService);
  private prestatieService = inject(PrestatieService);
  private clientService = inject(ClientService);
  private thuisverzorgerService = inject(ThuisverzorgerService);
  private dienstService = inject(DienstService);
  private tipService = inject(TipService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  user$: Observable<User>;
  prestatie$: Observable<Prestatie>;
  client$: Observable<Client>;
  thuisverzorger$: Observable<Thuisverzorger>;
  diensten$: Observable<Diensten>;
  taakTipAantallen$: Observable<Array<TaakTipAantal>>;

  ngOnInit(): void {
    this.user$ = this.authService.getUser$();
    this.prestatie$ = this.route.paramMap.pipe(
      map(paramMap => paramMap.get('prestatieId')),
      mergeMap(id => this.prestatieService.getPrestatie$(id)),
    );
    this.client$ = this.prestatie$.pipe(
      first(),
      mergeMap(prestatie => this.clientService.getClientById$(prestatie.getClientId())),
    );
    this.thuisverzorger$ = this.prestatie$.pipe(
      first(),
      map(prestatie => ({id: prestatie.getThuisverzorgerId(), nummer: prestatie.getThuisverzorgerNummer()})),
      mergeMap(thuisverzorgerId => this.thuisverzorgerService.getThuisverzorgersByIds$([thuisverzorgerId])),
      map(thuisverzorgers => thuisverzorgers[0]),
    );
    this.diensten$ = zip(
      this.dienstService.getDiensten$(),
      this.prestatie$,
    )
      .pipe(map(([diensten, prestatie]: [Diensten, Prestatie]) => diensten.filterForPrestatie(prestatie)));
    this.taakTipAantallen$ = this.client$.pipe(
      first(),
      mergeMap(client => this.tipService.getTaakTipAantallen(client.getId()))
    );
  }

  navigateToMeldingen(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/meldingen`);
  }

  navigateToPrestaties(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/prestaties`);
  }

  navigateToTips(client: Client, [dienstId, categorieId, taakId]: [string, string, string]): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/tips/dienst/${dienstId}/categorie/${categorieId}/taak/${taakId}`);
  }
}
